import Box from '@mui/material/Box';

import ThemeProvider from 'src/theme';

import { SettingsValueProps } from 'src/components/settings';

type Props = {
  children: React.ReactNode;
  themeMode: SettingsValueProps['themeMode'];
};

export default function DarkModeWrapper({ children, themeMode = 'dark' }: Readonly<Props>) {
  return (
    <ThemeProvider themeMode={themeMode} preserveState>
      <Box className={themeMode === 'dark' ? 'dark-theme' : 'light-theme'}>{children}</Box>
    </ThemeProvider>
  );
}
